export default __webpack_public_path__ + "static/media/activePop.3215d287.svg";